import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/*
 * The Subframe text styles (`text-body`, `text-heading-2`, ...) set size,
 * line-height and weight at once. tailwind-merge would otherwise file them under
 * text-colour and let `text-body text-heading-2` keep both; registering them as
 * their own group that conflicts with the individual font utilities makes
 * `cn("text-body", "text-heading-2")` resolve to the latter, as expected.
 */
const FONT_MIXINS = [
  "text-caption",
  "text-caption-bold",
  "text-body",
  "text-body-bold",
  "text-heading-3",
  "text-heading-2",
  "text-heading-1",
  "text-monospace-body"
];

const twMerge = extendTailwindMerge<"font-mixin">({
  extend: {
    classGroups: {
      "font-mixin": FONT_MIXINS
    },
    conflictingClassGroups: {
      "font-mixin": ["font-size", "leading", "font-weight"],
      "font-size": ["font-mixin"],
      leading: ["font-mixin"],
      "font-weight": ["font-mixin"]
    }
  }
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
